import React from 'react';
import {
 SideNavigation,
 Flash
} from 'AWS-UI-Components-React';
import BONESMidwayJavaScriptClient from 'BONESMidwayJavaScriptClient';

export const Header = ({title, counter}) => {

  return <div className='awsui-util-action-stripe'>
    <div className='awsui-util-action-stripe-title'>
      <h2>{title}&nbsp;
        {counter ? <span className='custom-action-stripe-counter'>{counter}</span> : ''}
      </h2>
    </div>
    <div className='awsui-util-action-stripe-group'>
    </div>
  </div>
};

export const FlashMessage = () => (
  <Flash
    type='success'
    content='Resource created successfully'
    dismissible={true}
  ></Flash>
);

export class JSClient {

    constructor(props){
        this.props = props || {};
        this.clientLoaded = this.clientLoaded.bind(this);
        this.getBeers = this.getBeers.bind(this);
        this.getBeer = this.getBeer.bind(this);
        this.getIdentity = this.getIdentity.bind(this);
        this.postBeer = this.postBeer.bind(this);
        new BONESMidwayJavaScriptClient({onReady : this.clientLoaded});
    }

    clientLoaded(client){
        this.client = client;
        if (this.props.hasOwnProperty("onReady")){
            this.props.onReady();
        }
    }

    postBeer(callback, errorCallback, beerName, description) {
      this.client.post(`beers`, {
        name: beerName,
        description: description
      }).then( function(response){
          callback(response.data);
      }).catch(function (error) {
        console.log(error);
        if (errorCallback) {
          errorCallback(error);
        }
      });
  }

    getIdentity(callback, errorCallback){
        this.client.get(`identity`)
        .then( function(response){
            callback(response.data);
        }).catch(function (error) {
          console.log(error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
    }

    getBeers(callback, errorCallback) {
        this.client.get(`beers`).then( function(response){
            callback(response.data);
        }).catch(function (error) {
          console.log(error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
    }

    getBeer(id, callback, errorCallback) {
      this.client.get(`beers/${id}`).then( function(response){
          callback(response.data);
      }).catch(function (error) {
        console.log(error);
        if (errorCallback) {
          errorCallback(error);
        }
      });
    }
};


export class Navigation extends React.Component {
  onFollowHandler(ev) {
    // keep the locked href for our demo pages
    ev.preventDefault();
  }

  render() {
    return (
      <SideNavigation
        //items={items}
        //header={header}
        //activeHref={this.props.activeHref}
        //onFollow={this.onFollowHandler.bind(this)}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/common.jsx